<template>
  <b-card class="info" style="padding: 10px; box-sizing: content-box">
    <div
      :class="{ 'report-violence-card-container': report }"
      style="display: flex; flex-direction: column"
    >
      <div>
        <h4 class="card-title" style="text-align: center">
          <div style="margin: 0 auto; min-height: 50px">
            {{ $t(data.title) }}
          </div>
        </h4>
      </div>
      <div>
        <!--        <div md="7" >-->
        <div
          class="responsive-width"
          style="display: table-cell; width: 58%; vertical-align: top"
        >
          <div
            ref="text"
            class="minH"
            :class="smallFont ? 'small-font' : ''"
            :style="{ 'min-height': calculatedHeight - 60 + 'px' }"
          >
            {{ $t(data.description) }}
          </div>
          <div
            class="web report-violence-card-indicator-value"
            style="text-align: center; width: 100%"
          >
            <div
              v-if="data.value"
              id="generalIndex"
              :class="
                data.value >= data.ranges.interMin1
                  ? data.value > data.ranges.posMin1
                    ? 'positive'
                    : 'intermediate'
                  : 'negative'
              "
              class="general-index center-block"
            >
              {{ data.value | currency("", 0, { thousandsSeparator: "" }) }}%
            </div>
            <div v-if="!data.value" class="general-index center-block negative">
              0%
            </div>
          </div>
        </div>
        <!--        </div>-->
        <!--        <b-col md="5">-->
        <div
          :id="alias"
          class="responsive-width"
          style="
            display: table-cell;
            width: 42%;
            vertical-align: top;
            text-align: center;
          "
        />
        <!--        </b-col>-->
      </div>
      <div
        class="mobile report-violence-card-indicator-value"
        style="text-align: center; width: 100%"
      >
        <div
          v-if="data.value"
          id="generalIndex"
          :class="
            data.value >= data.ranges.interMin1
              ? data.value > data.ranges.posMin1
                ? 'positive'
                : 'intermediate'
              : 'negative'
          "
          class="general-index center-block"
        >
          {{ data.value | currency("", 0, { thousandsSeparator: "" }) }}%
        </div>
        <div v-if="!data.value" class="general-index center-block negative">
          0%
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { ChartGauge } from "@/utils/ChartGauge";
import * as _ from "lodash";

export default {
  name: "CardChartGaugeOrganizationalViolence",
  props: {
    title: {
      default: "",
    },
    description: {
      default: "",
    },
    alias: {
      default: "",
    },
    calculatedHeight: {
      default: 0,
    },
    data: {
      default: null,
    },
    smallFont: {
      default: false,
    },
    report: {
      default: false,
    },
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      svg.selectAll(".gauge").remove();
      setTimeout(() => this.updateGauge(), 200);
    },
  },
  mounted() {
    // This let update the graphic when the language change
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "SET_LANG":
          var svg1 = this.$d3.select("#" + this.alias);
          svg1.selectAll(".gauge").remove();
          this.updateGauge();
          break;
      }
    });
    /*    setTimeout(() =>
      this.updateGauge(), 200)*/
    const callback = _.debounce(this.onResize, 0);
    // eslint-disable-next-line no-undef
    this.ro = new ResizeObserver(callback).observe(this.$refs.text);
  },
  beforeDestroy() {
    console.log("Destroy Gauge!!!");
    this.unsubscribe();
    this.ro.unobserve(this.$refs.text);
  },
  methods: {
    updateGauge() {
      if (this.data) {
        this.createGauge(this.data);
      }
    },
    createGauge(indicator) {
      var tempRanges = indicator.ranges;
      var rangez = [
        tempRanges.negMin1 === "Infinity"
          ? tempRanges.negMax1 * 1.2
          : tempRanges.negMin1,
        tempRanges.negMax1,
        tempRanges.interMin1,
        tempRanges.interMax1,
        tempRanges.posMin1,
        tempRanges.posMax1,
        tempRanges.interMin2,
        tempRanges.interMax2,
        tempRanges.negMin2,
        tempRanges.negMax2 === "Infinity"
          ? tempRanges.negMin2 * 1.2
          : tempRanges.negMax2,
      ];
      var rangezDescending = rangez.slice().sort(this.$d3.descending);
      var rangezAscending = rangez.slice().sort(this.$d3.ascending);
      var min = Math.min(
        rangezAscending[0],
        indicator.markers[0],
        indicator.ideals[0]
      );
      var max = Math.max(
        rangezDescending[0],
        indicator.markers[0],
        indicator.ideals[0]
      );
      var config = {
        min: Math.round(min * 100) / 100, // indicator.negMin1,
        max: Math.round(max * 100) / 100, // indicator.negMax2,
        minorTicks: 10,
        majorTicks: 10,
        radius: 1,
        fullHeight: true,
        margin: { top: 10, right: 0, bottom: 0, left: 0 },
      };
      config.redZones = [
        { from: config.min, to: indicator.ranges.negMax1 },
        {
          from: indicator.ranges.negMin1,
          to: config.max,
        },
      ];
      config.yellowZones = [
        {
          from: indicator.ranges.interMin1,
          to: indicator.ranges.interMax1,
        },
        { from: indicator.ranges.interMin2, to: indicator.ranges.interMax2 },
      ];
      config.greenZones = [
        { from: indicator.ranges.posMin1, to: indicator.ranges.posMax1 },
      ];
      this.gauges = new ChartGauge(config, this.alias);
      this.gauges.setHasErrorOnValueFormula(indicator.errorOnValueFormula);
      this.gauges.render();
      this.gauges.redraw(indicator.value, undefined, ".0f");
      this.$emit("minHeight", this.gauges.svgHeight);
    },
    onResize() {
      var svg1 = this.$d3.select("#" + this.alias);
      svg1.selectAll(".gauge").remove();
      this.updateGauge();
    },
  },
};
</script>
<style lang="scss">
.small-font {
  font-size: 0.9rem;
  min-height: 148px !important;
}

.IndicatorAddComment {
  color: #949293;
  position: absolute;
  bottom: 15px;
  right: 15px;
  font-weight: bold;
  cursor: pointer;

  .IndicatorAddCommentPlus {
    font-size: 30px;
    font-weight: 100;
    background-color: #949293;
    color: #ffffff;
    padding: 2px;
    line-height: 29px;
    display: inline-block;
    margin-left: 10px;
  }
}
</style>

<style lang="scss" scoped>
/* components/cards/CardIndicatorInfo*/

@import "../../assets/css/variables.scss";

.indexs {
  display: flex;
  justify-content: center;

  .convention {
    font-size: 1rem;
    text-align: center;
    margin: 0 10px;
    font-weight: bold;
    font-family: $font-subtitle;
    width: 115px;
  }

  p {
    margin-bottom: 0;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .index {
    top: 0px;
    padding: 0 10px;
    font-size: 2rem;
    border-radius: 5px;
    color: #ffffff;
    text-align: center;
  }
}

.dark {
  background-color: #000;
}

.compact {
  .card-subtitle {
    font-size: 1rem;
    margin: 0;
  }

  .card-text {
    font-size: 0.8rem;
    margin: 0px;
  }

  .convention {
    font-size: 0.8rem;

    .index {
      font-size: 1.6rem;
    }
  }
}
</style>

<style lang="scss" scoped>
.general-index {
  font-size: 2rem;
  border-radius: 20px;
  text-align: center;
  width: 100px;
  margin: 0 auto;
}

.col-8 {
  padding-right: 5px;
}

.col {
  padding-left: 5px;
}

.report-violence-card-container {
  .report-violence-card-indicator-value {
    /*    position: absolute;
    bottom: 10px;*/
  }
}
@media screen and (max-width: 700px) {
  .responsive-width {
    width: 100% !important;
    display: block !important;
    min-height: 100px;
  }
  .mobile {
    display: block !important;
  }
  .web {
    display: none !important;
  }
  .minH {
    min-height: 0 !important;
  }
}
.mobile {
  display: none;
}
</style>
